export default __webpack_public_path__ + "35c8175e0c55c79aba28a59ab18acb31.jpg";